import { gql } from '@apollo/client'
import employeeSkillStatusFragment from '../skill-status/employeeSkillStatus.fragment'

export const SUBORDINATES = gql`
  query Subordinates($companyId: HashedId!, $buId: HashedId, $reviewer: Boolean!, $country: Country!) {
    subordinates(companyId: $companyId, buId: $buId, reviewer: $reviewer) {
      id
      firstName
      lastName
      avatarUrl
      companyName
      country
      contractLevel
      branchOfficeCode
      currencyForPayments
      replyEntryDate
      contractValidTo
      resultScore
      timezone
      businessUnit {
        id
        name
      }
      salary {
        id
        amount
        fromDate
        toDate
        isTentative
        isFulltime
        note
        percentageOfWorktime
        currency
      }
      targetBonus {
        id
        amount
        fromDate
        toDate
        isTentative
        note
        currency
      }
      careerPathEvaluation {
        salaryEvaluation
        bonusEvaluation
        summary
        salary
        targetBonus
      }
      careerPath {
        careerPathType
        country
        level
        min
        max
      }
      skillStatus {
        ...SkillStatusFragment
      }
    }
    employeeLevels: getCountryEmployeeLevels(country: $country)
  }
  ${employeeSkillStatusFragment}
`

export const SUBORDINATE_SEARCH = gql`
  query SubordinateSearch($search: String!, $pagination: CursorPaginationSubordinateInput!) {
    subordinateSearch(search: $search, pagination: $pagination) {
      edges {
        id
        firstName
        lastName
        avatarUrl
        companyName
        businessUnitName
        contractLevel
        replyEntryDate
        contractValidTo
        employmentStatus
      }
      endCursorId
      endCursorLegalFirstName
      endCursorLegalLastName
      hasNextPage
    }
  }
`
